<app-header [icon]="'close'" (iconClickedEvent)="close()"></app-header>
<app-stepper #stepper></app-stepper>
<div class="container" [class]="moods[value()-1].class">
  
  <div class="sub-container">
    <div class="question">{{'moods.title' | translate}}</div>
    
    <div class="mood-label">{{moods[value()-1].label | translate}}</div>
  </div>

  <div class="sub-container">
    <div class="icon-container">
      <img [src]="moods[value()-1].image" [alt]="moods[value()-1].label" class="mood-icon">
    </div>
    
    <mat-slider
      [max]="5"
      [min]="1"
      [step]="1"
      >
        <input matSliderThumb [(ngModel)]="value" #slider (input)="onSliderChange($event)">
    </mat-slider>
  </div>

  <div class="actions-container">
    <app-button
      [buttonLabel]="'buttons.next' | translate"
      [buttonType]="BUTTON_TYPES.REGULAR" 
      [buttonDisabled]="false"
      (click)="next()">
    </app-button>
  </div>
</div>